import {
	DefaultStyledInputCalendarComponents,
	type InputBaseProps,
	type StyledInputCalendarComponents,
} from "@constellation-academy/framework-react-components";
import { Calendar as PrCalendar, type CalendarProps as PrCalendarProps } from "primereact/calendar";
import styled, { createGlobalStyle } from "styled-components";
import { DefaultInputStyles } from "../common/input.styles";

export const tkaAdminInputCalendarStyles: StyledInputCalendarComponents = {
	InputCalendar: {
		...DefaultStyledInputCalendarComponents.InputCalendar,
		StyledCalendar: styled(PrCalendar)<InputBaseProps & PrCalendarProps>`
			> input {
				${DefaultInputStyles()}
			}
		`,
		CalendarGlobalStyles: createGlobalStyle`
		`,
	},
};
